import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import Button from "../components/Button"
import AuthCard from "../components/AuthCard"
import requests from "../api/requests"
import { logout } from "../app/features/userSlice"
import {
  fetchSubscriptionStatus,
  selectHasAccess,
  selectPending,
  selectProvider,
  selectSubscriptionRawStatus,
  routeForStatus,
} from "../app/features/subscriptionStatusSlice"

const POLL_INTERVAL_MS = 30_000

/**
 * Shown to members whose subscription is `incomplete`: the first payment was
 * created but not confirmed yet. A Pix checkout resumes on /plan/pix (new QR);
 * a card waiting for 3DS (or an old boleto) finishes on the hosted invoice.
 */
export default function AwaitingPaymentScreen() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const pending = useSelector(selectPending)
  const status = useSelector(selectSubscriptionRawStatus)
  const provider = useSelector(selectProvider)
  const hasAccess = useSelector(selectHasAccess)
  const [verifying, setVerifying] = useState(false)
  // Redirects wait for the status fetched on mount, never the cached one.
  const [fresh, setFresh] = useState(false)

  useEffect(() => {
    dispatch(fetchSubscriptionStatus()).finally(() => setFresh(true))
    const t = setInterval(() => {
      dispatch(fetchSubscriptionStatus())
    }, POLL_INTERVAL_MS)
    return () => clearInterval(t)
  }, [dispatch])

  useEffect(() => {
    if (!fresh || !status) return
    if (hasAccess) navigate("/")
    else if (status === "incomplete" && provider === "asaas") navigate("/plan/pix")
    else if (routeForStatus(status) !== "/awaiting-payment") navigate(routeForStatus(status))
  }, [fresh, hasAccess, status, provider, navigate])

  const handlePay = () => {
    // Hosted invoice: a bearer URL, only handed to window.open.
    if (pending?.invoiceUrl) {
      window.open(pending.invoiceUrl, "_blank", "noopener,noreferrer")
    }
  }

  const handleVerify = async () => {
    if (verifying) return
    setVerifying(true)
    try {
      await dispatch(fetchSubscriptionStatus()).unwrap()
    } catch {
      // keep the screen as is
    } finally {
      setVerifying(false)
    }
  }

  const handleLogout = async () => {
    try {
      await requests.logout()
    } catch {
      // the session ends here anyway
    }
    dispatch(logout())
  }

  return (
    <AuthCard>
      <h1>Aguardando pagamento</h1>
      <h2>
        Estamos aguardando a confirmação do seu pagamento. Assim que ele for identificado, seu
        acesso é liberado automaticamente.
      </h2>

      {pending?.invoiceUrl && <Button onClick={handlePay} text="Concluir pagamento" />}

      <Button
        onClick={handleVerify}
        text={verifying ? "Verificando…" : "Já paguei, verificar"}
        disabled={verifying}
      />
      <p className="unpaid__logout-link" onClick={handleLogout}>
        Sair da conta
      </p>
    </AuthCard>
  )
}
